module.exports = __webpack_public_path__ + "static/media/footer_6.2cb0ed24.png";